import { useDeepSearch } from "@/hooks/useDeepSearch";
import { Header } from "@/components/Header";
import { SearchInput } from "@/components/SearchInput";
import { ChatMessage } from "@/components/ChatMessage";
import { StatusBar } from "@/components/StatusBar";
import { ExportPDFButton } from "@/components/ExportPDFButton";
import demoReports from "@/data/demoReports";
import hotTopics from "@/data/hotTopics.json";

function HomePage() {
  const { messages, isLoading, session, error, submitQuestion, loadDemoReport, cancelSearch, clearChat } = useDeepSearch();

  return (
    <div className="app">
      <Header onTitleClick={clearChat} />

      <main className="main-content">
        {messages.length === 0 ? (
          <div className="welcome-screen">
            <h2 className="welcome-title">开始你的深度研究</h2>
            <p className="welcome-subtitle">
              输入任何问题，AI 将为你进行全面的搜索和分析
            </p>

            {/* Demo Reports Section */}
            <div className="demo-section">
              <h3 className="demo-section-title">
                示例报告
                <span className="demo-badge">预览</span>
              </h3>
              <p className="demo-section-subtitle">
                点击查看预生成的演示报告，无需等待
              </p>
              <div className="example-questions">
                {demoReports.map((demo) => (
                  <div
                    key={demo.id}
                    className="example-tag example-tag-demo"
                    onClick={() => loadDemoReport(demo.id)}
                  >
                    <span className="demo-icon">⚡</span>
                    {demo.title}
                    <span className="demo-label">报告</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Regular Example Questions */}
            <div className="example-section">
              <h3 className="example-section-title">试试这些近期热门话题</h3>
              <div className="example-questions">
                {hotTopics.map((topic) => (
                  <div
                    key={topic.id}
                    className="example-tag"
                    onClick={() => submitQuestion(topic.question)}
                  >
                    {topic.icon} {topic.label}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="chat-container">
            {messages.map((message) => (
              <ChatMessage key={message.id} message={message} />
            ))}
            {error && (
              <div className="error-message">
                <span className="error-icon">⚠️</span>
                {error}
              </div>
            )}
          </div>
        )}
      </main>

      <footer className="app-footer">
        <div className="status-bar">
          <StatusBar session={session} isLoading={isLoading} />
          {session?.status === 'Completed' && (
            <ExportPDFButton messages={messages} sessionId={session.sessionId} />
          )}
          {messages.length > 0 && !isLoading && (
            <button className="clear-button" onClick={clearChat}>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
              清空对话
            </button>
          )}
        </div>
        <SearchInput onSubmit={submitQuestion} onCancel={cancelSearch} isLoading={isLoading} />
      </footer>
    </div>
  );
}

export default HomePage;
